'use strict';

var subElementCtrl = [function() {
    this.config = false;
    this.toggleConfig = function() {
        this.config = !this.config;
    };
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            removeElement: '&',
            cloneElement: '&',
            form: '=',
            subnodos: '=',
            reportConfig : "=",
            isForValidator: '=',
            pageIndex: '=',
            elementIndex: '=',
            subElementIndex: '=',
            subElement2Index: '=',
            subElement3Index: '=',
            isAdmin: '=',
        },
        replace: true,
        controller: subElementCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/subElement3Directive.html'
    };
};
